// extracted by mini-css-extract-plugin
export var logo = "_7t-2";
export var logoWrapper = "_7t-1";
export var strip = "_7t-0";